export default __webpack_public_path__ + "static/media/screenshort.c06981a9.svg";